@let activeCurrency = currency();
@let activeSummary = summary();
@let isCardLoading = isLoading() || !activeCurrency;

<div class="row g-3 mb-4">
    <!-- Total Invoiced (Amount + Count) -->
    <div class="col-12 col-xxl-4">
        <button type="button"
            class="stat-card-button w-100 text-start"
            [class.stat-card-selected]="selectedBucket() === 'all'"
            [attr.aria-pressed]="selectedBucket() === 'all'"
            aria-label="Filter by all invoices"
            (click)="onCardClick('all')">
            <div class="card h-100 stat-card">
                <div class="card-body d-flex align-items-center gap-2 gap-md-3 p-3 p-md-4">
                    <div class="rounded-circle d-flex align-items-center justify-content-center stat-icon-wrapper d-none d-sm-flex text-primary-bg">
                        <fa-duotone-icon icon="dollar-sign" class="text-primary" size="lg" secondaryOpacity="0.5" />
                    </div>
                    <div class="flex-grow-1 min-w-0">
                        @if (isCardLoading || !activeCurrency) {
                            <div class="placeholder-glow">
                                <span class="placeholder col-8 placeholder-sm mb-1 d-block"></span>
                                <span class="placeholder col-5 placeholder-lg"></span>
                            </div>
                        } @else {
                            <div class="text-muted small text-uppercase fw-semibold letter-spacing text-truncate">
                                Total Invoiced
                            </div>
                            <div class="fs-4 fs-md-3 fw-bold">
                                {{ (activeSummary?.totalAmountInvoiced ?? 0) | CurrencyDisplay: activeCurrency }}
                            </div>
                            <div class="text-muted small">
                                {{ (activeSummary?.totalInvoices ?? 0) | number }} invoices
                            </div>
                        }
                    </div>
                    <fa-duotone-icon icon="filter" class="stat-filter-hint text-muted" secondaryOpacity="0.9" />
                </div>
            </div>
        </button>
    </div>

    <!-- Current (0-30 days) -->
    <div class="col-12 col-xxl-4">
        <button type="button"
            class="stat-card-button w-100 text-start"
            [class.stat-card-selected]="selectedBucket() === 'current'"
            [attr.aria-pressed]="selectedBucket() === 'current'"
            aria-label="Filter by current invoices, 0 to 30 days"
            (click)="onCardClick('current')">
            <div class="card h-100 stat-card">
                <div class="card-body d-flex align-items-center gap-2 gap-md-3 p-3 p-md-4">
                    <div class="rounded-circle d-flex align-items-center justify-content-center stat-icon-wrapper d-none d-sm-flex text-success-bg">
                        <fa-duotone-icon icon="calendar-check" class="text-success" size="lg" secondaryOpacity="0.5" />
                    </div>
                    <div class="flex-grow-1 min-w-0">
                        @if (isCardLoading || !activeCurrency) {
                            <div class="placeholder-glow">
                                <span class="placeholder col-8 placeholder-sm mb-1 d-block"></span>
                                <span class="placeholder col-5 placeholder-lg"></span>
                            </div>
                        } @else {
                            <div class="text-muted small text-uppercase fw-semibold letter-spacing text-truncate">
                                Current (0-30 days)
                            </div>
                            <div class="fs-4 fs-md-3 fw-bold">
                                {{ (activeSummary?.current0To30Amount ?? 0) | CurrencyDisplay: activeCurrency }}
                            </div>
                            <div class="text-muted small">
                                {{ (activeSummary?.current0To30Count ?? 0) | number }} invoices
                            </div>
                        }
                    </div>
                    <fa-duotone-icon icon="filter" class="stat-filter-hint text-muted" secondaryOpacity="0.9" />
                </div>
            </div>
        </button>
    </div>

    <!-- Past Due (>30 days) -->
    <div class="col-12 col-xxl-4">
        <button type="button"
            class="stat-card-button w-100 text-start"
            [class.stat-card-selected]="selectedBucket() === 'pastDue'"
            [attr.aria-pressed]="selectedBucket() === 'pastDue'"
            aria-label="Filter by past due invoices, greater than 30 days"
            (click)="onCardClick('pastDue')">
            <div class="card h-100 stat-card">
                <div class="card-body d-flex align-items-center gap-2 gap-md-3 p-3 p-md-4">
                    <div class="rounded-circle d-flex align-items-center justify-content-center stat-icon-wrapper d-none d-sm-flex text-danger-bg">
                        <fa-duotone-icon icon="triangle-exclamation" class="text-danger" size="lg" secondaryOpacity="0.5" />
                    </div>
                    <div class="flex-grow-1 min-w-0">
                        @if (isCardLoading || !activeCurrency) {
                            <div class="placeholder-glow">
                                <span class="placeholder col-8 placeholder-sm mb-1 d-block"></span>
                                <span class="placeholder col-5 placeholder-lg"></span>
                            </div>
                        } @else {
                            <div class="text-muted small text-uppercase fw-semibold letter-spacing text-truncate">
                                Past Due (&gt;30 days)
                            </div>
                            <div class="fs-4 fs-md-3 fw-bold">
                                {{ (activeSummary?.pastDueOver30Amount ?? 0) | CurrencyDisplay: activeCurrency }}
                            </div>
                            <div class="text-muted small">
                                {{ (activeSummary?.pastDueOver30Count ?? 0) | number }} invoices
                            </div>
                        }
                    </div>
                    <fa-duotone-icon icon="filter" class="stat-filter-hint text-muted" secondaryOpacity="0.9" />
                </div>
            </div>
        </button>
    </div>
</div>
